var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 6.24998V10.3409L12.0837 11.25M10.0003 18.125C7.67291 18.125 6.5092 18.125 5.5737 17.7976C3.89809 17.2113 2.58066 15.8939 1.99434 14.2183C1.66699 13.2828 1.66699 12.1191 1.66699 9.79165C1.66699 7.46423 1.66699 6.30052 1.99434 5.36502C2.58066 3.68941 3.89809 2.37198 5.5737 1.78566C6.5092 1.45831 7.67291 1.45831 10.0003 1.45831C12.3277 1.45831 13.4914 1.45831 14.427 1.78566C16.1026 2.37198 17.42 3.68941 18.0063 5.36502C18.3337 6.30052 18.3337 7.46423 18.3337 9.79165C18.3337 12.1191 18.3337 13.2828 18.0063 14.2183C17.42 15.8939 16.1026 17.2113 14.427 17.7976C13.4914 18.125 12.3277 18.125 10.0003 18.125Z",
    stroke: "current",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.e1cd96b14c5cdc6d5b10e5959cda2f0d.svg";
export { ForwardRef as ReactComponent };